angular
	.module 'App.Value'
	.value 'termsAndConditionsUrl',
		(ALLOW_SELF_REGISTRATION, TERMS_URL, ConfigurationService) ->
			# If there is self-registration form enabled, then force static terms & conditions url
			# because users accepts only static T&C, not merchant group specific
			if ALLOW_SELF_REGISTRATION
				return TERMS_URL
			else
				return ConfigurationService.get 'Backoffice.Setting.TermsUrl', true
